/* eslint-disable no-unused-vars */
import React, { useState, useRef, useEffect, useContext, useCallback } from 'react';
import { List, Datagrid, FunctionField, SimpleList, ResourceContextProvider, useRefresh, RefreshIconButton } from 'react-admin';
import {
    useMediaQuery, makeStyles, Button, Dialog, DialogContent, DialogActions, IconButton, ListItem, ListItemIcon, ListItemText,
    TextField, Checkbox, Select, FormControl, MenuItem, Tooltip, DialogContentText, InputLabel, Typography, Switch, FormControlLabel, FormGroup, Accordion,
    AccordionSummary,
    AccordionDetails
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { customTheme } from "./customTheme";
import CustomSearch from './components/CustomSearch';
import { useLocation } from 'react-router-dom';
import CustomPagination from './components/CustomPagination';
import moment from 'moment';
import ScrollableTable from './components/ScrollableTable';
import UseAnalyticsEvent from './utils/useAnalyticsEvent';
import notify from './components/CustomUseNotify';
import config from "./config.json";
import { saveTokens } from './utils/saveTokens';
import CustomDateTimePicker from './components/CustomDateTimePickerV4';
import EmojiTransportationOutlinedIcon from "@material-ui/icons/EmojiTransportationOutlined";
import { stringify } from 'query-string';
import EditIcon from '@material-ui/icons/Edit';
import CircularProgress from '@material-ui/core/CircularProgress';
import DownloadIcon from "@material-ui/icons/GetApp";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import CustomFilter from './components/CustomFilter';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardTimePicker, TimePicker } from '@material-ui/pickers';
import CustomDeleteButton from './CustomDeleteButton';
import { Chip, DialogTitle } from '@mui/material';
import { withStyles } from '@material-ui/core';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { translate, crudUpdate } from 'ra-core';
import { KeyboardDatePicker } from "@material-ui/pickers";
import ReplayIcon from '@material-ui/icons/Replay';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { ContextProvider } from './globalContextProvider';
import GetAppIcon from '@material-ui/icons/GetApp';
import { useDropzone } from 'react-dropzone';
import * as CSV from 'csv-string';

const useStyles = makeStyles({
    list: {
        marginBottom: 0,
    },
    parkingSelectorContainer: {
        display: "grid",
        justifyContent: "space-between",
    },
    dialogPaper: {
        borderRadius: 15,
        padding: "5px 15px 15px",
        maxWidth: 600
    },
    boldText: {
        fontFamily: "Poppins-SemiBold"
    },
    lightText: {
        fontFamily: "Poppins-Regular"
    },
    tooltip: {
        fontFamily: "Poppins-Regular",
        fontSize: 12,
        letterSpacing: "0.04em"
    },
    autocomplete: {
        '& .MuiAutocomplete-inputRoot': {
            height: '44px',
        },
        '& .MuiInputLabel-outlined': {
            marginTop: -5
        },
        '& .MuiOutlinedInput-root': {
            padding: "0px 8px",
            '& fieldset': {
                borderColor: '#C2CFE0'
            },
            '&:hover fieldset': {
                borderColor: '#C2CFE0'
            },
            '&.Mui-focused fieldset': {
                borderColor: '#C2CFE0'
            },
        },
        '& .MuiOutlinedInput-notchedOutline': {
            outline: 'none'
        },
    },
    formControl: {
        '& .MuiSelect-select': {
            height: '22.5px',
        },
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#C2CFE0',
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#C2CFE0',
        },
        '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#C2CFE0',
        }
    },
    textField: {
        '& .MuiInputLabel-outlined': {
            marginTop: -5
        },
        '& .MuiOutlinedInput-root': {
            height: '44px',
            '& fieldset': {
                borderColor: '#C2CFE0',
            },
            '&:hover fieldset': {
                borderColor: '#C2CFE0',
            },
            '&.Mui-focused fieldset': {
                borderColor: '#C2CFE0',
            },
        },
    },
    checkbox: {
        '& .MuiSvgIcon-root': {
            fontSize: 20,
            color: '#C2CFE0'
        },
    },
});

const REQUESTER_FORM = "REQUESTER_FORM";
const DETAILS = "DETAILS";
const ONBOARDING_STATUS = {
    "INITIATED": { label: "INITIATED", color: "#334D6E", backgroundColor: "#334D6E19" },
    "PROCESSING": { label: "PROCESSING", color: "#334D6E", backgroundColor: "#334D6E19" },
    "COMPLETED": { label: "COMPLETED", color: "#18CC69", backgroundColor: "#18CC6919" },
    "ERROR": { label: "ERROR", color: "#F74E3D", backgroundColor: "#F74E3D19" },
    "FAILED": { label: "FAILED", color: "#F74E3D", backgroundColor: "#F74E3D19" },
    "PARTIALLY COMPLETED": { label: "PARTIALLY COMPLETED", color: "#18CC69", backgroundColor: "#18CC6919" },
}

const checkboxes = [
    { name: 'only_update_anpr_permit', label: 'Only consider ANPR permits' },
];

const BulkUpdatePermitFastag = props => {
    const classes = useStyles();
    const [currentTab, setCurrentTab] = React.useState(REQUESTER_FORM);

    return <div className={classes.list} style={{ position: "relative" }}>
        <div style={{ display: "flex", alignItems: "center", columnGap: 25, fontWeight: 600, marginTop: 20, marginBottom: 10, fontSize: 14, border: "none" }}>
            <div onClick={() => setCurrentTab(REQUESTER_FORM)} style={{ paddingBottom: 3, borderBottom: currentTab === REQUESTER_FORM ? "solid 3px #18cc69" : "#18cc69", color: "#334D6E", cursor: 'pointer', fontFamily: currentTab === REQUESTER_FORM ? 'Poppins-Medium' : 'Poppins-Regular', fontSize: 14 }}>
                Update FASTag
            </div>
            <div onClick={() => setCurrentTab(DETAILS)} style={{ paddingBottom: 3, borderBottom: currentTab === DETAILS ? "solid 3px #18cc69" : "#18cc69", color: "#334D6E", cursor: 'pointer', fontFamily: currentTab === DETAILS ? 'Poppins-Medium' : 'Poppins-Regular', fontSize: 14 }}>
                Details
            </div>
        </div>

        {currentTab === REQUESTER_FORM && <UpdateFastagForm setCurrentTab={setCurrentTab} />}

        {currentTab === DETAILS && <Details />}

    </div>
};

const UpdateFastagForm = ({setCurrentTab}) => {
    const eventTracker = UseAnalyticsEvent();
    const classes = useStyles();
    const refresh = useRefresh();
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    const [onboardingType, setOnboardingType] = useState("Update Fastag")
    const pathName = "updateFastagDetails"
    let prevSearch = sessionStorage.getItem(pathName) ? JSON.parse(sessionStorage.getItem(pathName)) : ""
    const [currentParking, setCurrentParking] = useState(prevSearch.currentParking ? prevSearch.currentParking : {});
    const zoneIds = currentParking.zone_ids ? currentParking.zone_ids.split(",") : null;
    const zoneLabels = currentParking.zones ? currentParking.zones.split(";") : null;
    const finalZones = zoneIds && zoneLabels ? zoneIds.map((id, index) => (
        { id, name: zoneLabels[index] }
    )) : null;
    if (finalZones)
        finalZones.sort((a, b) => (a.name > b.name ? 1 : (a.name < b.name ? -1 : 0)));;
    const [fileDetails, setFileDetails] = useState(null)
    const [checkedState, setCheckedState] = useState({
        only_update_anpr_permit: false,
    })
    const [loading, setLoading] = useState(false)

    const handleCheckboxChange = (event) => {
        const { name, checked } = event.target;
        setCheckedState(prevState => ({
            ...prevState,
            [name]: checked
        }));
    };

    const onParkingChange = (parking) => {
        setCurrentParking({ ...parking, allZones: true });
    };

    const onZoneChange = (event) => {
        setCurrentParking({
            ...currentParking,
            id: event.target.value,
            name: zoneLabels[zoneIds.findIndex(id => id === event.target.value)],
            allZones: event.target.value === "All"
        });
    };

    const bulkUpdatePermitFastagHandler = () => {
        let params = {
            user_id: sessionStorage.getItem("user_id"),
            access_key_id: currentParking.id,
            parking_info_id: currentParking.allZones ? currentParking.parking_info_id : null,
            onboarding_type: onboardingType,
            conditions: JSON.stringify({ ...checkedState })
        }

        if (!params.access_key_id) return notify("Parking is required", "warning");
        if (!params.onboarding_type) return notify("Onboarding type is required", "warning");

        setLoading(true)
        fetch(`${config.HOST_NAME}/crm/bulkUpdatePermitFastag`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            },
            body: JSON.stringify(params)
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then(json => {
                if (json.success) {
                    notify('Request have been submitted', "success");
                    setCurrentTab(DETAILS)
                    refresh();
                } else {
                    notify(json.message, "warning");
                }
            })
            .catch(error => {
                console.log(error)
                notify('Something went wrong', 'warning');
            })
            .finally(() => setLoading(false))
    }

    return <>

        <div className={classes.parkingSelectorContainer} style={{ gridAutoFlow: isSmallDevice ? "row" : "column", gridTemplateColumns: isSmallDevice ? "100%" : "50% 50%", gridRowGap: isSmallDevice ? 18 : 0, margin: 0 }}>

            <ParkingSearchSelector
                value={currentParking}
                onChange={onParkingChange}
                clearable={true}
                pathName={pathName}
            />


            {currentParking.zone_ids && currentParking.zone_ids.includes(',') &&
                <FormControl className={classes.formControl} variant="outlined" size='small' style={{ marginTop: isSmallDevice ? 0 : 10 }}>
                    <InputLabel>Zone Name</InputLabel>
                    <Select
                        value={currentParking.allZones ? "All" : currentParking.id}
                        onChange={onZoneChange}
                        label="Zone Name"
                        variant="outlined"
                    >
                        <MenuItem value="All">All</MenuItem>
                        {finalZones.map((zone, index) => (
                            <MenuItem key={index} value={zone.id}>{zone.name}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            }
        </div>

        <div style={{ marginTop: 16 }}>
            <Accordion defaultExpanded>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <Typography style={{ color: "#495057", fontWeight: 600, fontSize: 14 }}>Conditions</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <div>
                        {checkboxes.map(checkbox => (
                            <div>
                                <FormControlLabel
                                    key={checkbox.name}
                                    control={
                                        <Checkbox
                                            checked={checkedState[checkbox.name]}
                                            onChange={handleCheckboxChange}
                                            name={checkbox.name}
                                            className={classes.checkbox}
                                        />
                                    }
                                    label={<Typography style={{ color: "#495057", fontSize: 14 }}>{checkbox.label}</Typography>}
                                />
                            </div>
                        ))}
                    </div>
                </AccordionDetails>
            </Accordion>
        </div>

        <div style={{ marginTop: 16 }}>
            <Accordion defaultExpanded>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <Typography style={{ color: "#495057", fontWeight: 600, fontSize: 14 }}>Instructions</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <div style={{ color: "#495057", fontSize: 14 }}>
                        <div>As per above mentioned details by you please follow the below given instructions for CSV File.</div>
                        <ol>
                            <li>
                            The system supports a maximum of 1000 FASTag update requests per day.
                        </li>
                        <li>
                            Each individual permit/user is counted as one request.
                        </li>
                        <li>
                            If multiple bulk requests are submitted (for example, 5 requests with 200 permits each),
                            the total combined count must not exceed 1000 per day.
                        </li>
                        <li>
                            Once the daily limit of 1000 is reached, additional FASTag update requests
                            will not be processed for that day.
                        </li>
                        <li>
                            If ANPR permit checking is enabled, only permits that are whitelisted
                            with ANPR RFID will be considered for FASTag fetching.
                        </li>
                        </ol>
                    </div>
                </AccordionDetails>
            </Accordion>
        </div>

        <div style={{ width: "97%", padding: 16, backgroundColor: "#F5F5F5", display: "flex", justifyContent: "flex-end", alignItems: "center", marginTop: 60 }}>
            <Button
                onClick={() => bulkUpdatePermitFastagHandler()}
                color="primary"
                variant="contained"
                style={{ textTransform: "none", fontSize: 12, fontFamily: "Poppins-SemiBold", letterSpacing: "0.06em", height: "42px", backgroundColor: "#18CC69", color: "#FFF", borderRadius: 5, minWidth: 250 }}
                disableElevation
            >
                Upload {loading && <CircularProgress size={14} style={{ marginLeft: 15, color: "#FFF" }} />}
            </Button>
        </div>

    </>
}

const Details = (props) => {
    const classes = useStyles();
    const location = useLocation();
    const refresh = useRefresh();
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    let prevSearch = sessionStorage.getItem(location.pathname) ? JSON.parse(sessionStorage.getItem(location.pathname)) : ""
    const [currentParking, setCurrentParking] = useState(prevSearch.currentParking ? prevSearch.currentParking : {});
    const zoneIds = currentParking.zone_ids ? currentParking.zone_ids.split(",") : null;
    const zoneLabels = currentParking.zones ? currentParking.zones.split(";") : null;
    const finalZones = zoneIds && zoneLabels ? zoneIds.map((id, index) => (
        { id, name: zoneLabels[index] }
    )) : null;
    if (finalZones)
        finalZones.sort((a, b) => (a.name > b.name ? 1 : (a.name < b.name ? -1 : 0)));;
    const [startDateTime, setStartDateTime] = useState(null);
    const [endDateTime, setEndDateTime] = useState(null);
    const [search, setSearch] = useState(prevSearch.inputSearch)
    let searchTypeState = ["File Name"]
    const [searchTypes, setSearchTypes] = useState(prevSearch.type ? prevSearch.type : "File Name");
    const filter = { start_time: startDateTime ? moment(startDateTime).format("YYYY-MM-DD HH:mm:ss") : "", end_time: endDateTime ? moment(endDateTime).format("YYYY-MM-DD HH:mm:ss") : "", search: { value: search ? search : "", type: searchTypes ? searchTypes : "" }, access_key: currentParking.id, parking_info_id: currentParking.allZones ? currentParking.parking_info_id : undefined };

    const onParkingChange = (parking) => {
        setCurrentParking({ ...parking, allZones: true });
    };

    const onZoneChange = (event) => {
        setCurrentParking({
            ...currentParking,
            id: event.target.value,
            name: zoneLabels[zoneIds.findIndex(id => id === event.target.value)],
            allZones: event.target.value === "All"
        });
    };

    const download = (url) => {
        const tempLinkElement = document.createElement('a');
        tempLinkElement.target = "_blank";
        tempLinkElement.href = url;
        let filename;
        if (typeof url === "string") {
            const urlKeys = url.split("/");
            filename = urlKeys[urlKeys.length - 1];
        } else {
            filename = "Download";
        }
        tempLinkElement.setAttribute('download', filename);
        tempLinkElement.click();
    };

    return <>
        <div className={classes.parkingSelectorContainer} style={{ gridAutoFlow: isSmallDevice ? "row" : "column", gridTemplateColumns: isSmallDevice ? "100%" : "50% 50%", gridRowGap: isSmallDevice ? 18 : 0, margin: 0 }}>

            <ParkingSearchSelector
                value={currentParking}
                onChange={onParkingChange}
                clearable={true}
                pathName={location.pathname}
            />


            {currentParking.zone_ids && currentParking.zone_ids.includes(',') &&
                <FormControl className={classes.formControl} variant="outlined" size='small' style={{ marginTop: isSmallDevice ? 0 : 10 }}>
                    <InputLabel>Zone Name</InputLabel>
                    <Select
                        value={currentParking.allZones ? "All" : currentParking.id}
                        onChange={onZoneChange}
                        label="Zone Name"
                        variant="outlined"
                    >
                        <MenuItem value="All">All</MenuItem>
                        {finalZones.map((zone, index) => (
                            <MenuItem key={index} value={zone.id}>{zone.name}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            }
        </div>
        <div className='customStyleForDataSearchDiv' style={{ marginTop: 20 }}>
            <CustomSearch search={search} setSearch={setSearch} searchTypes={searchTypes} setSearchTypes={setSearchTypes} searchTypeState={searchTypeState} pathName={location.pathname} />
            <CustomDateTimePicker startDateTime={startDateTime} setStartDateTime={setStartDateTime} endDateTime={endDateTime} setEndDateTime={setEndDateTime} />
            <RefreshIconButton size={25} color="primary" />
        </div>
        <ResourceContextProvider value="bulkUpdatePermitFastag">
            <List
                style={{ marginTop: 20 }}
                {...props}
                basePath='/bulkUpdatePermitFastag'
                title="Bulk Update Permit Fastag"
                bulkActionButtons={false}
                exporter={false}
                filter={filter}
                empty={false}
                pagination={<CustomPagination />}
                actions={false}
                sort={{ field: "requested_on", order: "DESC" }}
            >
                {isSmallDevice ?
                    <SimpleList
                        primaryText={record => record.full_name || record.username || "-"}
                        secondaryText={record => (<div>
                            {record.onboarding_type && <div><span style={{ color: "#5a5a5a" }}>Onboarding Type: </span>{record.onboarding_type}</div>}
                            {record.file_name && <div><span style={{ color: "#5a5a5a" }}>File Name: </span>{record.file_name}</div>}
                            {record.status && <div><span style={{ color: "#5a5a5a" }}>Status: </span>{record.status}</div>}
                            {record.remark && <div><span style={{ color: "#5a5a5a" }}>Remark: </span>{record.remark}</div>}
                            {record.requested_on && <div><span style={{ color: "#5a5a5a" }}>Requested At: </span>{moment(record["requested_on"]).format("YYYY-MM-DD hh:mm:ss")}</div>}
                            {record.updated_on && <div><span style={{ color: "#5a5a5a" }}>Updated At: </span>{moment(record["updated_on"]).format("YYYY-MM-DD hh:mm:ss")}</div>}
                            {record.parking_name && <div><span style={{ color: "#5a5a5a" }}>Parking: </span>{record.parking_name}</div>}
                        </div>)}
                        onContextMenu={event => event.preventDefault()}
                        linkType={false}
                        rowStyle={() => ({ alignItems: "flex-start", borderBottom: "1px solid #18cc69" })}
                    />
                    :
                    <Datagrid className='customStyleDataGrid' component={ScrollableTable}>
                        {/* <FunctionField source="name" label="Report Type" render={record => <div style={{ textTransform: "capitalize", color: "#707683", fontWeight: 600 }}>{record.name.replaceAll("_", " ").toLowerCase()}</div>} sortable /> */}
                        <FunctionField source="onboarding_type" label="Request Type" sortable={false} render={record => record && record.onboarding_type ? record.onboarding_type : '-'} />
                        <FunctionField source="file_name" label="File Name" sortable={false} render={record => record && record.file_name ? <div style={{width: "200px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{record.file_name}</div>: '-'} />
                        <FunctionField source="requested_on" label="Requested At" render={record => record && record.requested_on ?
                            <div>
                                <div style={{ color: "#707683", fontWeight: 600 }}>{moment(record.requested_on).format("hh:mm A")}</div>
                                <div style={{ color: "#AAAAAA" }}>{moment(record.requested_on).format("DD/MM/YYYY")}</div>
                            </div>
                            : "-"
                        }
                        />
                        <FunctionField source="updated_on" label="Updated At" render={record => record && record.updated_on ?
                            <div>
                                <div style={{ color: "#707683", fontWeight: 600 }}>{moment(record.updated_on).format("hh:mm A")}</div>
                                <div style={{ color: "#AAAAAA" }}>{moment(record.updated_on).format("DD/MM/YYYY")}</div>
                            </div>
                            : "-"
                        }
                        />
                        <FunctionField source="status" label="Status" sortable={false} render={record => record && record.status && ONBOARDING_STATUS[record.status] ? <div className='fontWeightBold' style={{ padding: "2px 4px", borderRadius: 2, ...ONBOARDING_STATUS[record.status] }}>{ONBOARDING_STATUS[record.status].label}</div> : "-"} />
                        <FunctionField source="total_records_for_onboarding" label="Permits" sortable={false} render={record => (
                            <div>
                                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                    <div>{record && record.total_records_for_onboarding ? record.total_records_for_onboarding : '-'}</div>
                                    {record && record.invalid_permits_file_url && <div>
                                        <IconButton title='Records File' size='small' style={{ marginLeft: 10 }} onClick={() => download(record.invalid_permits_file_url)}>
                                            <DownloadIcon style={{ fontSize: 18, color: "#334D6E" }} />
                                        </IconButton>
                                    </div>
                                    }
                                </div>
                                {/* {record && record.file_url && <div style={{ color: "#AAAAAA" }}>{moment(record.requested_on).add(30, "days").format("DD/MM/YYYY")}</div>} */}
                            </div>
                        )} />
                        <FunctionField source="invalid" label="Not-Updated/Failed" sortable={false} render={record => (
                            <div>
                                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                    <div>{record && record.invalid ? record.invalid : '-'}</div>
                                </div>
                                {/* {record && record.invalid_permits_file_url && <div style={{ color: "#AAAAAA" }}>{moment(record.requested_on).add(30, "days").format("DD/MM/YYYY")}</div>} */}
                            </div>
                        )} />
                        <FunctionField source="onboarded" label="Updated" sortable={false} render={record => record && record.onboarded ? record.onboarded : '-'} />
                        <FunctionField source="already_existed" label="Existed" sortable={false} render={record => record && record.already_existed ? record.already_existed : '-'} />
                        <FunctionField source="requested_by_user_id" label="Requested By" sortable={false} render={record => record.full_name || record.username || '-'} />
                        <FunctionField source="parking_name" label="Parking Name" sortable={false} render={record => record && record.parking_name ? record.parking_name : '-'} />
                        {/* <FunctionField source="remark" label="Remark" render={record => record && record.remark ? record.remark : '-'} /> */}
                    </Datagrid>
                }
            </List>
        </ResourceContextProvider>
    </>
}

const ParkingSearchSelector = (props) => {
    const classes = useStyles();
    const { setIsChange } = useContext(ContextProvider);
    const { value, onChange, zones, label = "Parking Name", style, clearable = true, filter, routeUrl = "parkings", pathName, ...restProps } = props;
    const [parkings, setParkings] = useState([]);
    const [parkingsLoading, setParkingsLoading] = useState(false);
    const [parkingFilter, setParkingFilter] = useState("");

    const fetchParkingTimeout = useRef(null);

    const handleParkingFilterChange = (event, value) => {
        setParkingFilter(value);
    };

    const fetchParkings = () => {
        setParkingsLoading(true);
        var params = {
            user_id: sessionStorage.getItem("user_id"),
            filter: JSON.stringify({ name: parkingFilter, zones, includeSocieties: true, ...filter }),
            page: 1,
            perPage: 10
        }
        fetch(`${config.HOST_NAME}/crm/v3/${routeUrl}?${stringify(params)}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            },
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then((responseJson) => {
                setParkingsLoading(false);
                if (responseJson.success) {
                    setParkings(responseJson.data);
                    setIsChange(false)
                } else {
                    notify(responseJson.message, 'warning');
                }
            })
            .catch((e) => {
                notify('Error fetching Parkings', 'warning')
            });
    };

    React.useEffect(() => {
        setIsChange(false)
        if (fetchParkingTimeout.current)
            clearTimeout(fetchParkingTimeout.current);
        fetchParkingTimeout.current = setTimeout(fetchParkings, 500);
    }, [parkingFilter]);  // eslint-disable-line react-hooks/exhaustive-deps

    return <Autocomplete
        className={classes.autocomplete}
        blurOnSelect
        disableClearable={!clearable}
        getOptionLabel={parking => parking ? (zones ? parking.name : parking.general_name) : ""}
        getOptionSelected={(option, value) => option.id === value.id}
        loading={parkingsLoading}
        noOptionsText="No Parkings"
        onInputChange={handleParkingFilterChange}
        options={parkings}
        renderInput={params => <TextField {...params} label={label} variant="outlined" />}
        onChange={(event, value) => {

            if (sessionStorage.getItem(pathName)) {
                let prevdata = JSON.parse(sessionStorage.getItem(pathName))
                sessionStorage.setItem(`${pathName}`, JSON.stringify({ ...prevdata, currentParking: { ...value, allZones: true } }))
            } else {
                sessionStorage.setItem(`${pathName}`, JSON.stringify({ currentParking: { ...value, allZones: true } }))
            }
            onChange(value)
            setIsChange(true)
        }}
        value={value}
        style={{ marginTop: 10, ...style }}
        {...restProps}
    />;
}

const DragAndDropFileUploader = ({ fileDetails, setFileDetails }) => {

    const onDrop = useCallback((acceptedFiles) => {
        if (acceptedFiles.length > 0) {
            setFileDetails({ fileName: acceptedFiles[0].name, file: acceptedFiles[0] });
        } else setFileDetails(null);
    }, [setFileDetails]);

    const { getRootProps, getInputProps, isDragActive, isDragReject } = useDropzone({
        onDrop,
        accept: '.csv',
        multiple: false,
    });

    return (
        <div>
            <div {...getRootProps()} style={{ height: '110px', width: '100%', border: '2px dashed #cccccc', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', backgroundColor: '#f9f9f9', marginTop: '16px', }}>
                <input {...getInputProps()} />
                {isDragActive ?
                    (<p>Drop the CSV file here...</p>)
                    : isDragReject ?
                        (<p>Unsupported file type. Only CSV files are accepted.</p>)
                        : fileDetails?.fileName ?
                            (<p>Selected file: {fileDetails.fileName}</p>)
                            :
                            (<p>Drag & drop a CSV file here, or click to select one</p>)
                }
            </div>
        </div>
    );
};

export default BulkUpdatePermitFastag